"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { getInternalLinks } from "@/lib/seo/internalLinks";

interface InternalLinksProps {
  title?: string;
}

export function InternalLinks({
  title = "İlginizi Çekebilir",
}: InternalLinksProps) {
  const pathname = usePathname();
  // Path temizleme (normalize)
  const normalizedPath = (pathname || "").split("?")[0];
  const links = getInternalLinks(normalizedPath);

  if (!links || links.length === 0) return null;

  return (
    <div className="my-16 p-8 border border-gray-100 rounded-3xl bg-gradient-to-br from-gray-50/50 to-white shadow-sm">
      <h3 className="text-2xl font-bold mb-6 text-gray-900">{title}</h3>
      <div className="flex flex-wrap gap-3">
        {links.map((link) => (
          <Link
            key={link.url}
            href={link.url}
            className="px-5 py-2.5 bg-white border border-gray-200 rounded-xl hover:border-blue-500 hover:text-blue-600 hover:shadow-md transition-all text-sm font-semibold text-gray-700 flex items-center gap-2 group"
          >
            <span>{link.anchor}</span>
            <svg
              className="w-4 h-4 transform group-hover:translate-x-1 transition-transform"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </Link>
        ))}
      </div>
    </div>
  );
}
